import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable()
export class AppUrl {
    baseUrl: string = environment.apiConfig.baseUrl;

    constructor() {}

    public TEST_RANK_ID(testId): string {
        return this.APP_URL_V1_ADMIN + `test-rank/${testId}`;
    }

    public get TEST_RANK(): string {
        return this.APP_URL_V1_ADMIN + 'test-rank';
    }

    public get BOOKS(): string {
        return this.APP_URL_V1_ADMIN + 'books';
    }

    public get PATHSHALA_CENTER_LIST(): string {
        return this.APP_URL_V1_ADMIN + 'pathshala/center';
    }

    public get FAQ_CATEGORY(): string {
        return this.APP_URL_V1_ADMIN + 'faq-category';
    }

    public get CATEGORY(): string {
        return this.APP_URL_V1_ADMIN + 'test-category';
    }

    public get BATCH_CATEGORY(): string {
        return this.APP_URL_V1_ADMIN + 'batch-categories';
    }

    public get USERS_V2(): string {
        return this.APP_URL_V2_ADMIN + 'users';
    }

    public PREFERENCES(orgId): string {
        return this.APP_URL_V1_ADMIN + `organizations/${orgId}/preferences`;
    }

    public GET_SLIDES_LIST(
        batchId: string,
        subjectId: string,
        scheduleId: string,
    ): string {
        return (
            this.APP_URL_V1_ADMIN +
            `batches/${batchId}/subject/${subjectId}/schedule/${scheduleId}/slides`
        );
    }

    public TEST_RANK_EXCEL(testId): string {
        return this.APP_URL_V1_ADMIN + `test-rank/${testId}/download-excel`;
    }

    public get APP_URL_V3(): string {
        return 'v3/';
    }

    public get APP_URL_V1_ADMIN(): string {
        return 'v1/admin/';
    }

    public get APP_URL_V2_ADMIN(): string {
        return 'v2/admin/';
    }

    public get PERMISSIONS(): string {
        return `${this.APP_URL_V1_ADMIN}users/permissions`;
    }

    public get MCQS(): string {
        return this.APP_URL_V1_ADMIN + 'mcqs';
    }

    public MCQS_ID(questionId): string {
        return this.APP_URL_V1_ADMIN + `mcqs/${questionId}`;
    }

    /**
     * SAARTHI
     */

    public GET_SAARTHI_PLANS(saarthiId: string): string {
        return this.APP_URL_V3 + `admin/saarthi/${saarthiId}/plan`;
    }

    /**
     * AddOns
     */
    public BATCH_ADDONS(batchId): string {
        return this.APP_URL_V1_ADMIN + `batches/${batchId}/addons`;
    }

    public BATCH_ADDONS_UPDATE(batchId, addonId): string {
        return this.APP_URL_V1_ADMIN + `batches/${batchId}/addons/${addonId}`;
    }

    public PACKAGE_ADDONS(packageId): string {
        return this.APP_URL_V1_ADMIN + `packages/${packageId}/addons`;
    }

    public UPDATE_MENTORSHIP(batchId): string {
        return this.APP_URL_V1_ADMIN + `batches/${batchId}/update-mentorship`;
    }

    //   ================  Community and Super40 Related API Starts ==========================
    public get APP_URL_COMMUNITY(): string {
        return 'v3/admin/community';
    }

    public get GET_COMMINITY_USERS(): string {
        return `${this.APP_URL_COMMUNITY}/users`;
    }

    public get GET_SUPER40_CHANNELS(): string {
        return `${this.APP_URL_COMMUNITY}/channels/super40-channels`;
    }

    public get GET_CHANNELS_MEMBERS(): string {
        return `${this.APP_URL_COMMUNITY}/channels/members`;
    }

    public get MUTE_CHANNEL_MEMBER(): string {
        return `${this.APP_URL_COMMUNITY}/channels/mute`;
    }

    public get GET_SUPER40_MENTORS(): string {
        return `${this.APP_URL_COMMUNITY}/channels/mentors`;
    }

    public get REMOVE_SUPER40_MENTOR(): string {
        return `${this.APP_URL_COMMUNITY}/channels/remove-mentor`;
    }

    public PATCH_ROLES(userId: string): string {
        return `${this.APP_URL_COMMUNITY}/users/${userId}`;
    }

    public get TEACHER_UPLOAD(): string {
        return `${this.APP_URL_COMMUNITY}/users/update-batch-with-csv`;
    }

    public get CREATE_SUPER40_CHANNEL(): string {
        return `${this.APP_URL_COMMUNITY}/channels/super40-channels`;
    }

    public UPDATE_SUPER40_CHANNEL(channelId): string {
        return `${this.APP_URL_COMMUNITY}/channels/${channelId}`;
    }

    public get SUPER40_REPORT(): string {
        return `${this.APP_URL_COMMUNITY}/batches/download-super40`;
    }

    public get MENTOR_UPLOAD(): string {
        return `${this.APP_URL_COMMUNITY}/channels/batch-mentor-assign-with-csv`;
    }

    public get STUDENT_UPLOAD(): string {
        return `${this.APP_URL_COMMUNITY}/channels/add-users-to-super40`;
    }

    COHORT_LANDING_QUESTIONS_ROOT(): string {
        return `${this.APP_URL_V1_ADMIN}batches/cohort-landing-questions/root`;
    }

    COHORT_LANDING_QUESTIONS(nodeId: string): string {
        return `${this.APP_URL_V1_ADMIN}batches/cohort-landing-questions/${nodeId}`;
    }

    COHORT_LAYER_DELETE(nodeId: string): string {
        return `${this.APP_URL_V1_ADMIN}batches/onboarding-layer/${nodeId}`;
    }

    //   ================  Community and Super40 Related API Starts ==========================
}
